import { useState, useCallback } from "react";

interface Toast {
	id: string;
	title?: string;
	description?: string;
	variant?: "default" | "destructive";
}

export function useToast() {
	const [toasts, setToasts] = useState<Toast[]>([]);

	const toast = useCallback(
		({
			title,
			description,
			variant = "default",
		}: Omit<Toast, "id">) => {
			// For now, just console log the toast
			// In a real implementation, this would show a toast notification
			console.log(`Toast: ${title} - ${description}`);
			
			const newToast: Toast = {
				id: Date.now().toString(),
				title,
				description,
				variant,
			};

			setToasts((prev) => [...prev, newToast]);

			// Auto-remove after 3 seconds
			setTimeout(() => {
				setToasts((prev) => prev.filter((t) => t.id !== newToast.id));
			}, 3000);
		},
		[]
	);

	return { toast, toasts };
}